import { AdvancedDynamicTexture } from "@babylonjs/gui";
export const getAdvancedDynamicTexture = (scene) => {
    const adt = scene.textures.find((texture) => texture.name === 'GUI');
    return adt !== undefined
        ? adt
        : AdvancedDynamicTexture.CreateFullscreenUI('GUI');
};
